import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const DASHBOARD_BY_TYPE = {
  customer: '/customer/dashboard',
  pharmacy: '/pharmacy/dashboard',
  rider: '/rider/dashboard',
  admin: '/admin'
};

const ProtectedRoute = ({ children, allowedUserTypes = [] }) => {
  const { isAuthenticated, user, loading, requiresProfileSetup } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect pharmacy users to setup if they need to complete their profile
  if (requiresProfileSetup && user.userType === 'pharmacy' && location.pathname !== '/pharmacy-setup') {
    return <Navigate to="/pharmacy-setup" replace />;
  }

  // Wrong account type for this page → send them to their own dashboard
  if (allowedUserTypes.length > 0 && !allowedUserTypes.includes(user.userType)) {
    const home = DASHBOARD_BY_TYPE[user.userType] || '/';
    return <Navigate to={home} replace />;
  }

  return children;
};

export default ProtectedRoute;
